
import React, { Component } from 'react';
import DataGrid, { Column, Scrolling, Pager, Paging, SearchPanel, ColumnFixing } from 'devextreme-react/data-grid';
import { Tabs, Tab } from 'react-bootstrap';
import { connect } from 'react-redux';
import closeGrid from '../../../images/icons/closeGrid.png';
import './DashboardList.css';
import setActionDashboardlist from '../../../actions/setActionDashboardlist';
import setActionRefreshDashboard from '../../../actions/setActionRefreshDashboard';

import updateWorkplace from '../../../images/icons/updateWorkplace.png';
import { Tooltip } from 'devextreme-react/tooltip';
import chartIcon from "../../../images/chart.png";


class DashboardList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

            withAnimationVisible: false,
            withAnimationVisibleclosegrid: false,
            showColumnLines: false,
            showRowLines: true,
            showBorders: true,
            rowAlternationEnabled: true

        };

        this.toggleWithAnimation = this.toggleWithAnimation.bind(this);
        this.togglewithAnimationVisibleclosegrid = this.togglewithAnimationVisibleclosegrid.bind(this);
        this.onValueChanged = this.onValueChanged.bind(this);

    }

    closeGrid = (e) => {

        this.props.actionDashboardlistset(undefined)
    }
    CellPrepared = e => {
        if (e.rowType === "data" && e.columnIndex === 0) {
            e.cellElement.title = 'Double click if you want to navigate to dashboard';
        }
    }
    mouseover = e => {

        if (e.rowType === 'data' && e.columnIndex === 0) {
            if (e.eventType === 'mouseover') {
                e.cellElement.style.color = "steelblue";
                e.cellElement.style.textDecoration = "underline";
                e.cellElement.style.cursor = "pointer";

            } else {
                e.cellElement.style.color = "Black";
                e.cellElement.style.textDecoration = "";
            }
        }



    }
    dashboard = e => {

        var contextSelection
        var contextRoots
        var contextParents
        if (this.props.contextSelectionState !== undefined) {

            contextSelection = this.props.contextSelectionState.map((c) => '{' + c.id + '}:{' + c.beid + '}').join(',')
            contextRoots = this.props.contextSelectionState.map((c) => c.root).join(':')
            contextParents = this.props.contextSelectionState.map((c) => c.parent).join(':')
        }
        var taskName = this.props.taskNameState.replace("<b style=margin-right:69px>", "(").replace("</b>", ")")
        window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState +  "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + e.data.id + "&folderid=" + this.props.folderIdState + "&reportname=" + e.data.name + "&createdby=" + e.data.userName)

        //var taskName = this.props.taskNameState.replace("<b style=margin-right:69px>", "(").replace("</b>", ")")
        //window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState + "&contextselection=" + this.props.contextSelectionState.reduce((p, c) => `${p}${c.text},`, "").slice(0, -1) + "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + e.data.id + "&folderid=" + this.props.folderIdState + "&reportname=" + e.data.name + "&createdby=" + e.data.userName)

        //this.props.actionDashboardlistset(undefined)
    }
    refreshDashboard = e => {
        this.props.refreshDashboardlistset(true)
    }
    onValueChanged(e) {
        let optionName = null;
        switch (e.component.option('text')) {
            case 'Show Row Lines': {
                optionName = 'showRowLines';
                break;
            }
            case 'Show Borders': {
                optionName = 'showBorders';
                break;
            }
            case 'Alternating Row Color': {
                optionName = 'rowAlternationEnabled';
                break;
            }
            default: {
                optionName = 'showColumnLines';
                break;
            }
        }
        this.setState({
            [optionName]: e.value
        });
    }

    render() {
        const { showColumnLines, showRowLines, showBorders, rowAlternationEnabled } = this.state;

        if (this.props.dashboardlist !== undefined) {


            if (this.props.dashboardlist.length === 1) {

                var contextSelection
                var contextRoots
                var contextParents
                if (this.props.contextSelectionState !== undefined) {

                    contextSelection = this.props.contextSelectionState.map((c) => '{' + c.id + '}:{' + c.beid + '}').join(',')
                    contextRoots = this.props.contextSelectionState.map((c) => c.root).join(':')
                    contextParents = this.props.contextSelectionState.map((c) => c.parent).join(':')
                }
                var taskName = this.props.taskNameState.replace("<b style=margin-right:69px>", "(").replace("</b>", ")")
                //console.log('this.props.contextSelectionState')
                //console.log(this.props.contextSelectionState)
                if (this.props.contextSelectionState !== undefined) {
                    window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState + "&contextselection=" + this.props.contextSelectionState.reduce((p, c) => `${p}${c.text},`, "").slice(0, -1) + "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + this.props.dashboardlist[0].id + "&folderid=" + this.props.folderIdState + "&reportname=" + this.props.dashboardlist[0].name + "&createdby=" + this.props.dashboardlist[0].userName)
                    console.log(window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState + "&contextselection=" + this.props.contextSelectionState.reduce((p, c) => `${p}${c.text},`, "").slice(0, -1) + "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + this.props.dashboardlist[0].id + "&folderid=" + this.props.folderIdState + "&reportname=" + this.props.dashboardlist[0].name + "&createdby=" + this.props.dashboardlist[0].userName)
)
                } else {
                    window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState + "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + this.props.dashboardlist[0].id + "&folderid=" + this.props.folderIdState + "&reportname=" + this.props.dashboardlist[0].name + "&createdby=" + this.props.dashboardlist[0].userName)
                    console.log(window.open(window.location.href.substring(0, window.location.href.indexOf('taskview')) + 'dashboard' + '?taskname=' + taskName + "&foldername=" + this.props.folderNameState + "&userid=" + this.props.usedataState + "&roleid=" + this.props.roledataId + "&taskid=" + this.props.taskIdState + "&contextTemplateid=" + this.props.contextTemplateIdState + "&contextSelection=" + contextSelection + "&contextRoots=" + contextRoots + "&contextParents=" + contextParents + "&dashboardid=" + this.props.dashboardlist[0].id + "&folderid=" + this.props.folderIdState + "&reportname=" + this.props.dashboardlist[0].name + "&createdby=" + this.props.dashboardlist[0].userName)
)
                }
                this.props.actionDashboardlistset(undefined)
            }
            //if (this.props.dashboardlist.value.length > 1) {
            if (this.props.dashboardlist.length > 1) {

                return (
                    <div>
                        {/*<div style={{ position: 'inherit', marginLeft: '50%', marginTop:'-11px' }}>
                            <img
                                id="closeDashboard"
                                onMouseEnter={this.togglewithAnimationVisibleclosegrid}
                                onMouseLeave={this.togglewithAnimationVisibleclosegrid}
                                onClick={this.closeGrid.bind(this, undefined)} className="closeGrid" src={closeGrid} onClick={this.closeGrid} />
                            <Tooltip
                                target="#closeDashboard"
                                position="top"
                                visible={this.state.withAnimationVisibleclosegrid}
                                closeOnOutsideClick={false}
                            >
                                <div>Close Grid</div>
                            </Tooltip>
                        </div>*/}
                        {/*<p className="messageTab">Double click if you want to navigate to dashboard .</p>*/}
                        <p className="messagedashboard">
                            <span ></span><span className="backIcon" style={{ marginLeft: '31px', paddingTop: '5px' }}>Analytics</span>  <span data-dismiss="modal" className="close">&times;</span>
                            {/*<ul  className="content-modal" >

                                <li style={{ height: '50px', borderBottom: '1px solid #ddd', boxShadow: '0px 3px 6px #00000029', width: '100%', color: "#1B97E1", fontSize: '16px', marginTop: '-13px', paddingTop: '14px' }}>
                                  
                                </li>
                            </ul>*/}

                            {/*<img
                                id="refreshDashboard"
                                onMouseEnter={this.toggleWithAnimation}
                                onMouseLeave={this.toggleWithAnimation}
                                onClick={this.refreshDashboard}
                                className='refreshDashBoard'
                                style={{ height: '30px', width: '30px', zIndex: 10, color: "#fff", marginTop: '2px', marginLeft: '8px', cursor:'pointer' }}
                                src={updateWorkplace} />
                            <Tooltip
                                target="#refreshDashboard"
                                position="top"
                               
                                visible={this.state.withAnimationVisible}
                                closeOnOutsideClick={false}
                            >
                                <div>Update Dashboard Grid</div>
                            </Tooltip>*/}
                        </p>
                        <p className="messageTab">Double click if you want to navigate to dashboard .</p>
                        <p style={{ marginTop: '10px', float: 'left', borderBottom: '1px solid #ddd', paddingLeft: '0px', paddingRight: '0px', borderRight: '0px solid #ddd', borderLeft: '0px solid #ddd' }}>
                            <DataGrid

                                dataSource={this.props.dashboardlist}
                                showColumnLines={showColumnLines}
                                showRowLines={showRowLines}
                                showBorders={showBorders}
                                rowAlternationEnabled={rowAlternationEnabled}
                                columnAutoWidth={true}
                                selection={{ mode: 'single' }}

                                hoverStateEnabled={true}
                                keyExpr="id"
                                onCellHoverChanged={this.mouseover}
                                onCellPrepared={this.CellPrepared}
                                onCellDblClick={this.dashboard}
                                height={270}

                            >
                                <Column visible={false} dataField="id" caption="ID" cssClass="cell-highlighted" />
                                <Column dataField="name" caption="Dashboard Name" />
                                <Column dataField="userName" caption="Created By" />
                                <Column dataField="createdDate" sortOrder="desc" caption="Created Date" dataType='datetime' cssClass="cell-highlighted" />
                                <Scrolling mode="virtual" />
                            </DataGrid>
                        </p>
                        <p style={{ width: "100%", top: '0px', float: 'left', borderBottom: '0px solid #ddd', paddingLeft: '0px', paddingRight: '0px', borderRight: '0px solid #ddd', borderLeft: '0px solid #ddd' }}>
                            <button
                                data-dismiss="modal"
                                className="Modal100-form-btn"
                            >
                                Cancel
						    </button>
                        </p>
                    </div>

                );
            }
        }
        return null
    }
    toggleWithAnimation() {
        this.setState({
            withAnimationVisible: !this.state.withAnimationVisible
        });
    }
    togglewithAnimationVisibleclosegrid() {
        this.setState({
            withAnimationVisibleclosegrid: !this.state.withAnimationVisibleclosegrid
        });
    }
}

const mapStateToProps = state => {
    return {

        dashboardlist: state.currDashboardlistState,
        contextTemplateIdState: state.contextTemplateDataId,
        contextSelectionState: state.contextSelection,
        taskIdState: state.taskDataId,
        roledataId: state.roleDataId,
        usedataState: state.userData,
        folderIdState: state.folderDataId,
        taskNameState: state.taskDataName,
        folderNameState: state.folderDataName,

    }
};
const mapDispatchToProps = dispatch => {
    return {

        actionDashboardlistset: payload => dispatch(setActionDashboardlist(payload)),
        refreshDashboardlistset: payload => dispatch(setActionRefreshDashboard(payload)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(DashboardList);





// WEBPACK FOOTER //
// ./src/components/TaskView/WorkPlace/DashboardList.js